import React from 'react';
import { SymbolOverview } from 'react-tradingview-embed';
import "../screens/Home.css";

const TradingViewChart = () => {
  const widgetProps = {
    colorTheme: 'light',
    dateRange: '12M',
    showChart: true,
    locale: 'en',
    width: '100%',
    height: '100%',
    isTransparent: false,
    symbols: [
      [
        "BSE:SENSEX|1D|INR"
      ],
      [
        "FX_IDC:USDINR|1D|INR"
      ],
    ],
  };

  return (
    <>
      <SymbolOverview className="chart" widgetProps={widgetProps} />
    </>
  );
};

export default TradingViewChart;